/* eslint-disable @typescript-eslint/naming-convention */
const GEARBOXS = {
  automatic: {
    id: 'automatic',
    label: 'Automatic',
    selected: false,
  },
  automatic_gear: {
    id: 'automatic_gear',
    label: 'Automatic',
    selected: false,
  },
  manual: {
    id: 'manual',
    label: 'Manual',
    selected: false,
  },
  manual_gear: {
    id: 'manual_gear',
    label: 'Manual',
    selected: false,
  },
  semiauto: {
    id: 'semiauto',
    label: 'Semiauto',
    selected: false,
  },
  semiautomatic_gear: {
    id: 'semiautomatic_gear',
    label: 'Semi-automatic',
    selected: false,
  },
  none: {
    id: 'none',
    label: 'Other',
    selected: false,
  },
  unknown: {
    id: 'unknown',
    label: 'Unknown',
    selected: false,
  },
};

export { GEARBOXS };
